<template>
  <section class="mt-12 first:mt-0 md:mt-20" data-testid="experiences-section">
    <template v-for="(experienceSection, index) in props.experienceSections" :key="index + experienceSection.id">
      <section :data-testid="`experiences-section-${index}`">
        <h3 :id="experienceSection.id" class="mx-4 mb-5 flex scroll-mt-20 font-Spectral text-xl tracking-wide md:mx-0 md:mb-4 md:text-[26px] md:leading-[40px]">
          {{ experienceSection.title }}
          <span class="mx-2 flex flex-grow items-center">
            <span class="h-[0.5px flex-grow bg-beige3"></span>
          </span>
        </h3>
        <HorizontalScrollWrapper scroll-button-box-style="h-[157px] md:h-[228px]">
          <template v-for="(experience, j) in experienceSection.experiences" :key="j + experience.id">
            <ExperienceCard
              class="mb-2 w-[280px] shrink-0 overflow-hidden first:ml-4 last:mr-4 md:w-[360px] md:first:ml-0 md:last:mr-0"
              orientation="horizontal"
              theme="light"
              :data-testid="`experience-card-${index}`"
              :disable-carousel-on-sp="true"
              :experience="experience"
              :on-experience-click="(experienceSlug) => handleExperienceClick(experienceSection.webSectionId, experienceSlug)"
            />
          </template>
        </HorizontalScrollWrapper>
        <div v-if="experienceSection.destinationWebPath" class="mt-4 text-center">
          <NuxtLink class="bg-primary inline-block rounded-full px-6 py-2 text-white" :to="experienceSection.destinationWebPath" @click="handleUrlClick(experienceSection.webSectionId)"
            >もっと見る</NuxtLink
          >
        </div>
      </section>
      <!-- 8セクション目の下にGTAとギフトカードのバナーセクションを表示する -->
      <div v-if="index + 1 === 8 && props.shouldShowGiftCard" class="pb-12 md:pb-20">
        <BannerSection />
      </div>
    </template>
  </section>
</template>

<script lang="ts" setup>
import { HorizontalScrollWrapper } from '@/wabunka-src/common/components';
import BannerSection from '@/wabunka-src/common/components/pure/BannerSection/BannerSection.vue';
import { type ExperienceSectionListViewModel, ExperienceCard } from '@/wabunka-src/features/Experience';

interface Props {
  experienceSections: ExperienceSectionListViewModel;
  shouldShowGiftCard: boolean;
  onExperienceClick?: (sectionId: string, experienceSlug: string) => void;
  onViewAll?: (sectionId: string) => void;
}

const props = defineProps<Props>();

const handleExperienceClick = (sectionId: string, experienceSlug: string) => {
  if (props.onExperienceClick) {
    props.onExperienceClick(sectionId, experienceSlug);
  }
};

const handleUrlClick = (sectionId: string) => {
  if (props.onViewAll) {
    props.onViewAll(sectionId);
  }
};
</script>
